module.exports = __webpack_public_path__ + "static/img/75ee3b33.svg";